import React, { useState, useEffect } from "react";
import abbottLogo from "../img/Abbott_logo.png";
import checkIcon from "../img/check.png";
import fileIcon from "../img/file.png";
import rightArrowIcon from "../img/right-arrow.png";
// import calendarIcon from "../img/calendar.png";
import { ReactComponent as CalendarIcon } from '../img/calendar.svg';
import H2Logo from "../img/H2Logo.png";
import { productList } from "./ProductList";
import { Link, useLocation } from "react-router-dom";
import warning from "../img/warning.png";
import HeaderComponent from "./headerComponent";

const Product = () => {
  const location = useLocation();
  const [productData, setProductData] = useState(null); // State to hold product data

  //handle date format
  // const dataFormatter = (dateString) => {
  //   const year = "20" + dateString.substring(0, 2); // "27" -> "2027"
  //   const month = parseInt(dateString.substring(2, 4), 10) - 1; // "05" -> 4 (May)
  //   const day = dateString.substring(4, 6); // "27"

  //   // Create a Date object
  //   const dateObj = new Date(year, month, day);

  //   // Format the date in "dd MMM yyyy"
  //   const date = `${dateObj
  //     .getDate()
  //     .toString()
  //     .padStart(2, "0")} ${dateObj.toLocaleString("en-GB", {
  //     month: "short",
  //   })} ${dateObj.getFullYear()}`;

  //   return date; // Return the formatted date string, e.g., "27 May 2027"
  // };

  const dataFormatter = (dateString) => {
    const year = "20" + dateString.substring(0, 2); // "27" -> "2027"
    const month = dateString.substring(2, 4); // "09"
    const day = dateString.substring(4, 6); // "10"

    // Map month numbers to short names (use "Sept" for consistency)
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];

    const monthIndex = parseInt(month, 10) - 1;

    // Construct formatted date
    const formattedDate = `${day} ${monthNames[monthIndex]} ${year}`;
    return formattedDate;
  };

  useEffect(() => {
    let isProdcutFound = false; // Flag to check if product is found
    if (
      location.pathname.split("/")[3] === "01" &&
      location.pathname.split("/")[5] === "10" &&
      location.pathname.split("/")[7] === "21" &&
      new URLSearchParams(location.search).has("17")
    ) {
      const gtin = location.pathname.split("/")[4];
      const lot = location.pathname.split("/")[6];
      const serial = location.pathname.split("/")[8];
      const dateString = new URLSearchParams(location.search).get("17"); // Extract date from query string
      const formattedDate = dataFormatter(dateString);
      productList.forEach((product) => {
        if (
          product.gtin === gtin &&
          product.serial === serial &&
          product.lot === lot &&
          product.expDate === formattedDate
        ) {
          setProductData(product); // Set the product data if GTIN matches
          isProdcutFound = true; // Set the flag to true if product is found
        }
      });
    } else if (
      location.pathname.split("/")[3] === "01" &&
      location.pathname.split("/")[5] === "21"
    ) {
      const gtin = location.pathname.split("/")[4];
      const serial = location.pathname.split("/")[6];
      productList.forEach((product) => {
        if (product.gtin === gtin && product.serial === serial) {
          setProductData(product); // Set the product data if GTIN matches
          isProdcutFound = true; // Set the flag to true if product is found
        }
      });
    } else if (location.pathname.split("/")[3] === "21") {
      const sno = location.pathname.split("/")[4];
      productList.forEach((product) => {
        if (product.serial === sno) {
          setProductData(product); // Set the product data if GTIN matches
          isProdcutFound = true; // Set the flag to true if product is found
        }
      });
    } else if (location.pathname.split("/")[3] === "01") {
      const gtin = location.pathname.split("/")[4];
      productList.forEach((product) => {
        if (product.gtin === gtin) {
          if (gtin === "00813337017142") {
            setProductData(productList.find((po) => po.id === 5)); // Set the product data if GTIN matches
            isProdcutFound = true;
          } else {
            setProductData(product); // Set the product data if GTIN matches
            isProdcutFound = true;
          }
          // Set the flag to true if product is found
        }
      });
    } else {
      const gtin = location.pathname.split("/")[4];
      productList.forEach((product) => {
        if (product.gtin === gtin) {
          setProductData(product); // Set the product data if GTIN matches
          isProdcutFound = true; // Set the flag to true if product is found
        }
      });
    }

    if (!isProdcutFound) {
      window.location.href = "/Product/NotFound"; // Redirect to Not Found page if product is not found
    }
  }, [location.pathname]);

  // iPhone UI adjustments
  const [isIphone, setIsIphone] = useState(false);
  useEffect(() => {
    const checkIphone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
    setIsIphone(checkIphone);
  }, []);

  return (
    <div class="row w-100 g-0">
      <div class="col-12 d-none d-lg-block col-lg-5 bg-image vh-100 position-fixed">
        <div class="mask text-light d-flex flex-column p-5 vh-100 w-100">
          <div class="logo-div float-start">
            {/* <img src={abbottLogo} class="w-100" alt="abbott logo" /> */}
            <Link className="navbar-brand company-logo company-logo-base" to="/">
              {/* <img src={abbottLogo} alt="abbott logo" class="w-100" /> */}
            </Link>
          </div>
          <div class="mt-auto text-start test">
            <h3 class="fw-bold text-uppercase text-start">welcome to abbott</h3>
            <h3 class="fw-bold text-uppercase display-6 text-color-primary pb-5 text-start">
              product verification
            </h3>

            <span class="pt-5 text-uppercase text-start">
              *This is a mockup page showcasing digital serialization v2.8
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-7 offset-lg-5 d-flex flex-column vh-100">
        <div
          class="collapse mobile-nav-bar-menu-show"
          id="navbarToggleExternalContent"
          data-bs-theme="dark"
        >
          <div class="bg-dark p-4 text-start">
            <span class="text-body-secondary text-uppercase">
              *This is a mockup page showcasing digital serialization v2.8
            </span>
          </div>
        </div>

        <nav class="navbar navbar-dark bg-dark py-3 d-block d-lg-none">
          <div class="container-fluid px-4">
            <Link class="navbar-brand company-logo company-logo-base-mobile" to="/">
              {/* <img src={abbottLogo} alt="abbott logo" height="25" /> */}
            </Link>
            <button
              class="navbar-toggler border-0 ms-auto px-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarToggleExternalContent"
              aria-controls="navbarToggleExternalContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
        </nav>

        <div class="d-block d-lg-none top-bg-img-container">
          <div class="top-bg-img">
            <div class="top-bg-img-overlay">
              <div class="pt-5 px-4 text-start">
                <h3 class="fw-bold text-uppercase text-color-white text-start">
                  welcome to abbott
                </h3>
                <h3 class="fw-bold text-uppercase display-6 text-color-primary text-start">
                  product verification
                </h3>
              </div>
            </div>
          </div>
        </div>

        {productData !== null && (
          <>
            <div class="mt-lg-4 pt-4 main-content-padding">
              <HeaderComponent />

              <div class="mt-4 d-flex w-100 d-block d-lg-none">
                <div class="position-relative d-flex bg-color-white rounded-4 border border-light shadow-lg w-100 product-div">
                  <img
                    src={productData?.image}
                    class="rounded-4 float-start py-3 px-3 product-image"
                    alt="productImage"
                  />

                  <div class="correct-or-warning-icon position-absolute bottom-0 end-0">
                    <div class="animation-ctn">
                      <div class="icon icon--order-success svg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="50"
                          height="50"
                          viewBox="0 0 154 154"
                        >
                          {productData?.verified ? (
                            <g fill="none" stroke="#409f44" strokeWidth="2">
                              <circle
                                cx="77"
                                cy="77"
                                r="72"
                                style={{
                                  strokeDasharray: "480px, 480px",
                                  strokeDashoffset: "960px",
                                }}
                              ></circle>
                              <circle
                                id="colored"
                                fill="#409f44"
                                cx="77"
                                cy="77"
                                r="72"
                                style={{
                                  strokeDasharray: "480px, 480px",
                                  strokeDashoffset: "960px",
                                }}
                              ></circle>
                              <polyline
                                class="st0"
                                stroke="#fff"
                                strokeWidth="10"
                                points="43.5,77.8 63.7,97.9 112.2,49.4"
                                style={{
                                  strokeDasharray: "100px, 100px",
                                  strokeDashoffset: "200px",
                                }}
                              ></polyline>
                            </g>
                          ) : (
                            <g fill="none" stroke="#d65c02" strokeWidth="2">
                              <circle
                                cx="77"
                                cy="77"
                                r="72"
                                style={{
                                  strokeDasharray: "480px, 480px",
                                  strokeDashoffset: "960px",
                                }}
                              ></circle>
                              <circle
                                id="colored"
                                fill="#d65c02"
                                cx="77"
                                cy="77"
                                r="72"
                                style={{
                                  strokeDasharray: "480px, 480px",
                                  strokeDashoffset: "960px",
                                }}
                              ></circle>
                              <line
                                class="st0"
                                stroke="#fff"
                                strokeWidth="10"
                                x1="77"
                                y1="25"
                                x2="77"
                                y2="110"
                                style={{
                                  strokeDasharray: "50px, 50px",
                                  strokeDashoffset: "90px",
                                }}
                              ></line>
                              <circle
                                class="dot"
                                fill="#fff"
                                cx="77"
                                cy="110"
                                r="5"
                              ></circle>
                            </g>
                          )}
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center ms-0 pe-3 ms-lg-1">
                    <h1 class="fw-semibold text-start">{productData?.name}</h1>
                  </div>
                </div>
              </div>

              <div class="mt-4 d-none d-lg-flex animate__animated animate__fadeIn">
                <div class="position-relative d-flex rounded-4 border product-div">
                  {/* <img
                    src={productData?.image}
                    class="rounded-4 float-start py-3 px-3 product-image"
                    alt="productImage"
                  /> */}

                  <div className="image-container rounded-4">
                    <img
                      src={productData?.image}
                      class="rounded-4"
                      alt="productImage"
                    />
                  </div>

                  <div class="correct-or-warning-icon position-absolute bottom-0 end-0">
                    <div class="animation-ctn">
                      <div class="icon icon--order-success svg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="50"
                          height="50"
                          viewBox="0 0 154 154"
                        >
                          {productData?.verified ? (
                            <g fill="none" stroke="#409f44" strokeWidth="2">
                              <circle
                                cx="77"
                                cy="77"
                                r="72"
                                style={{
                                  strokeDasharray: "480px, 480px",
                                  strokeDashoffset: "960px",
                                }}
                              ></circle>
                              <circle
                                id="colored"
                                fill="#409f44"
                                cx="77"
                                cy="77"
                                r="72"
                                style={{
                                  strokeDasharray: "480px, 480px",
                                  strokeDashoffset: "960px",
                                }}
                              ></circle>
                              <polyline
                                class="st0"
                                stroke="#fff"
                                strokeWidth="10"
                                points="43.5,77.8 63.7,97.9 112.2,49.4"
                                style={{
                                  strokeDasharray: "100px, 100px",
                                  strokeDashoffset: "200px",
                                }}
                              ></polyline>
                            </g>
                          ) : (
                            <g fill="none" stroke="#d65c02" strokeWidth="2">
                              <circle
                                cx="77"
                                cy="77"
                                r="72"
                                style={{
                                  strokeDasharray: "480px, 480px",
                                  strokeDashoffset: "960px",
                                }}
                              ></circle>
                              <circle
                                id="colored"
                                fill="#d65c02"
                                cx="77"
                                cy="77"
                                r="72"
                                style={{
                                  strokeDasharray: "480px, 480px",
                                  strokeDashoffset: "960px",
                                }}
                              ></circle>
                              <line
                                class="st0"
                                stroke="#fff"
                                strokeWidth="10"
                                x1="77"
                                y1="25"
                                x2="77"
                                y2="110"
                                style={{
                                  strokeDasharray: "50px, 50px",
                                  strokeDashoffset: "90px",
                                }}
                              ></line>
                              <circle
                                class="dot"
                                fill="#fff"
                                cx="77"
                                cy="110"
                                r="5"
                              ></circle>
                            </g>
                          )}
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center ms-0 pe-3 ms-lg-4 ">
                  <h1 class="fw-semibold text-start">{productData?.name}</h1>
                </div>
              </div>

              <div class="w-100 mt-4 d-flex animate__animated animate__fadeInDown">
                <span class="fs-5 me-3">Serial:</span>
                <span class="fs-5 fw-semibold">{productData?.serial}</span>
              </div>
              <div class="w-100 my-3 d-flex text-start animate__animated animate__fadeInDown">
                <span class="fs-5 fw-semibold">{productData?.sublabel}</span>
              </div>

              <div class="w-100 detail-row-height description-div d-flex mb-lg-0 animate__animated animate__fadeInDown">
                <span class="fs-6">Description:</span>
                <span class="fs-6 fw-semibold text-gap text-start">
                  {productData?.description}
                </span>
              </div>

              <div class="d-flex detail-row-height my-1 animate__animated animate__fadeInDown">
                <div class="d-flex align-items-center">
                  <span class="fs-6">Expiry date:</span>
                  <span class="fs-6 fw-semibold me-4 number-gap">
                    {productData?.expDate}
                  </span>
                </div>

                {/* adds the expiry date to the calendar for verified products */}
                {productData?.verified && (
                  <button
                    onClick={(event) => {
                      event.preventDefault(); // Prevents unexpected navigation
                      window.open(productData?.calendar, "_self");
                    }}
                    class="btn secondary-border-color d-flex justify-content-center align-items-center px-3 fw-semibold calendar-icon-btn"
                  >
                    {/* <img
                      src={calendarIcon}
                      alt="Calendar Icon"
                      class="me-2 me-lg-3 icon-sizes calendar-icon"
                    /> */}

                    <CalendarIcon className="me-2 me-lg-3 icon-sizes calendar-icon" />

                    <span>Add to Calendar</span>
                  </button>
                )}
              </div>

              <div class="w-100 detail-row-height my-1 d-flex align-items-center animate__animated animate__fadeInDown">
                <span class="fs-6">Lot number:</span>
                <span class="fs-6 fw-semibold text-gap">
                  {productData?.lot}
                </span>
              </div>

              <div class="w-100 detail-row-height my-1 d-flex align-items-center animate__animated animate__fadeInDown">
                <span class="fs-6 me-4">Quality released:</span>
                <span class="fs-6 fw-semibold">
                  {productData?.quality ? "Yes" : "No"}
                </span>
              </div>

              <div class="row button-row animate__animated animate__fadeInDown">
                <div class="col-6">
                  <button
                    class="btn bg-color-primary text-color-white d-flex justify-content-center align-items-center w-100 mt-3 py-3 fw-semibold icon-btn"
                    type="button"
                    onClick={() => window.open(productData?.leaflet, "_blank")}
                  >
                    <img
                      src={fileIcon}
                      alt="File Icon"
                      class="me-2 me-lg-3 icon-sizes"
                    />
                    <span class="text-wrap">Download e-Leaflet</span>
                  </button>
                </div>

                <div class="col-6">
                  <button
                    class="btn bg-color-primary text-color-white d-flex justify-content-center align-items-center w-100 mt-3 py-3 fw-semibold icon-btn right-arrow-btn"
                    type="button"
                    onClick={() =>
                      window.open(productData?.productPage, "_blank")
                    }
                  >
                    <img
                      src={rightArrowIcon}
                      alt="Right Arrow Icon"
                      class="me-2 me-lg-3 icon-sizes"
                    />
                    <span class="text-wrap">Visit Product Page</span>
                  </button>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end mt-3 mt-lg-auto pb-2 main-content-padding animate__animated animate__fadeInDown">
              {/* <img src={H2Logo} alt="#" height="40" /> */}
              <a 
                href="https://h2compute.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                class="d-flex align-items-end text-decoration-none"
                style={{ cursor: 'pointer' }}
              >
                <span class="d-flex align-items-end me-2 text-color-gray small">
                  Powered by:{" "}
                </span>
                <span class="h2c-logo"></span>
              </a>
            </div>

            {/* {isIphone && (
              <div className="space-div">iPhone specific content</div>
            )} */}

            {isIphone &&
              (productData?.verified === false &&
              productData?.scanCountExceed ? (
                <div className="space-div countExceededProduct"></div>
              ) : productData?.verified ? (
                <div className="space-div verifiedProduct"></div>
              ) : (
                <div className="space-div expiredProduct"></div>
              ))}

            {productData?.verified === false && productData?.scanCountExceed ? (
              <div className="sticky-bottom col-12 mt-2 d-flex flex-column justify-content-center align-items-center bg-color-warning py-4 fw-bold fs-5 text-color-white main-content-padding animate__animated animate__fadeInUp animate__delay-1s">
                <div className="d-flex align-items-center flex-column footer-div-text">
                  <div className="d-flex flex-column align-items-center">
                    <div className="d-flex align-items-center mb-1">
                      <img
                        src={warning}
                        height="25"
                        width="25"
                        className="warning-icon"
                        alt=""
                      />
                      <span className="text-uppercase mt-1">
                        Suspicious Product
                      </span>
                    </div>
                    <div className="bottom-text-div">
                      <span className="desktop">
                        This code was scanned more than 250 times in different
                        locations.
                      </span>
                      <span className="mobile">
                        This code was scanned more than <br />
                        250 times in different locations.
                      </span>
                    </div>
                  </div>
                  <span className="fw-normal fs-6">
                    Please contact your nearest healthcare provider.
                  </span>
                </div>
              </div>
            ) : productData?.verified ? (
              <div className="sticky-bottom col-12 mt-2 d-flex justify-content-center align-items-center bg-color-success py-4 fw-bold fs-5 text-color-white animate__animated animate__fadeInUp animate__delay-1s">
                <img src={checkIcon} height="35" className="me-3" alt="" />
                This is a verified Abbott product.
              </div>
            ) : (
              <div className="sticky-bottom col-12 mt-2 d-flex flex-column justify-content-center align-items-center bg-color-warning py-4 fw-bold fs-5 text-color-white main-content-padding animate__animated animate__fadeInUp animate__delay-1s">
                <div className="d-flex align-items-center flex-column footer-div-text">
                  <div className="d-flex flex-column flex-lg-row align-items-center mb-0 mb-lg-2">
                    <img
                      src={warning}
                      height="25"
                      width="25"
                      className="mb-2 mb-lg-0 warning-icon"
                      alt=""
                    />

                    <span>This is a verified but expired product.</span>
                  </div>
                  <div className="d-flex flex-column flex-lg-row fw-normal">
                    <span className="fs-6 mobile">
                      Please contact your nearest healthcare provider <br />
                      for proper disposal.
                    </span>
                    <span className="fs-6 desktop">
                      Please contact your nearest healthcare provider for proper
                      disposal.
                    </span>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Product;
